import { render, staticRenderFns } from "./mobileBookDetail.vue?vue&type=template&id=6a59c396&scoped=true"
import script from "./mobileBookDetail.vue?vue&type=script&lang=js"
export * from "./mobileBookDetail.vue?vue&type=script&lang=js"
import style0 from "./mobileBookDetail.vue?vue&type=style&index=0&id=6a59c396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a59c396",
  null
  
)

export default component.exports